import { getEntryImages } from '@toasttab/shared/src/utils/siteUtils'
import { ArticleProps } from '../components/Article/Article'

export const transformContentfulArticle = (region: string, article: any) => {
  const cleanedTitle = (str: string): string => {
    return str.replace(/\[.*?\]\s*/g, '')
  }
  const regionArticle =
    article &&
    article.regions &&
    article.regions.find((x: any) => x.country === region)
  if (!regionArticle) return null
  const _article: ArticleProps = {
    __typename: article.__typename,
    title: regionArticle && cleanedTitle(regionArticle.title),
    heroTitle: regionArticle.hero?.headline,
    shortDescription: regionArticle.hero?.description?.description,
    slug: article.slug,
    entryImages: getEntryImages(
      regionArticle.hero,
      regionArticle.thumbnailImage
    ),
    onTheLineType: regionArticle.onTheLineType,
    onTheLineTopic: regionArticle.onTheLineTopic
  }
  return _article
}

export const getEntryCountByTopic = (
  region: string,
  allEntries: any[],
  topic: string
) => {
  let count = 0
  allEntries.forEach((entry: any) => {
    const regionEntry = entry.regions.find((x: any) => x.country === region)
    const entryTopic =
      regionEntry.onTheLineTopic &&
      regionEntry.onTheLineTopic.filter((t: any) => {
        return t.title === topic
      })
    if (entryTopic && entryTopic.length > 0) {
      count += 1
    }
  })
  return count
}

export const extractDateTime = (dateTime: string) => {
  const date = new Date(dateTime)
  const extractedDate = date.toDateString()
  const extractedTime = date.toLocaleTimeString()
  return { extractedDate, extractedTime }
}

export const titleToSlug = (title: string) => {
  return title?.trim().toLowerCase().replace(/ /g, '').replace(/\+/g, '-')
}
